import {
  call, put, takeLatest
} from "redux-saga/effects";
// Login Redux States
import {
  FETCH_REPORTS_START,
} from "./actionTypes";
import {
  fetchReportEnd,
} from "./actions";
import { showErrorNotification } from "store/notifications/actions";


import * as reportsApi from "../../apis/reports";

function* fetchReport(params) {
  try {
    const data = yield call(reportsApi.getReports, params);
    yield put(fetchReportEnd(data));
  }
  catch (error) {
    yield put(fetchReportEnd({
      docs: [],
      totals: null,
      totalDocs: 0,
      totalPages: 0,
      error: error.message
    }));
    yield put(showErrorNotification(error.message || "Unable to load report"));
  }

}
function* reportsSaga() {
  yield takeLatest(FETCH_REPORTS_START, fetchReport);
}

export default reportsSaga;
